import { render } from "./3D.vue?vue&type=template&id=8239964e&scoped=true"
import script from "./3D.vue?vue&type=script&lang=js"
export * from "./3D.vue?vue&type=script&lang=js"

import "./3D.vue?vue&type=style&index=0&id=8239964e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8239964e"]])

export default __exports__